// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Slider_arrow__mIhfj","prev":"Slider_prev__1avVD","next":"Slider_next__nkvJy","disabled":"Slider_disabled__cr1BR","wrapper":"Slider_wrapper__SmQBH"};